<template>
  <div class="text-left">
    <div class="mb-4">
      <div
        class="text-left custom-control custom-checkbox"
        :class="{ 'is-invalid': $v.termsOfUseAgreement.$error }"
      >
        <v-checkbox
          v-model="$v.termsOfUseAgreement.$model"
          :error="$v.termsOfUseAgreement.$error"
          class="mt-2"
          hide-details="auto"
          @change="updateValue"
          @click="sendGtmEvent('Souhlas se užíváním služby')"
        >
          <template #label>
            <template v-if="formName === 'AeskuLab'">
              <i18n path="aeskulab.form.termsConds.text">
                <template #link>
                  <span
                    class="link--inline"
                    @click.prevent.stop="
                      $eventHub.$emit(`openTermsConditionsModal_${inputData.id}`)
                    "
                    >{{ $t('aeskulab.form.termsConds.link') }}</span
                  >
                </template>
                <template #cookies>
                  <span
                    class="link--inline"
                    @click.prevent.stop="$eventHub.$emit(`openCookiesModal_${inputData.id}`)"
                    >{{ $t('aeskulab.form.termsConds.cookies') }}</span
                  >
                </template>
              </i18n>
            </template>
            <template v-else>
              <div>
                {{ $t('dataProcessing.iAgreeWith') }}&nbsp;
                <span
                  class="link--inline"
                  @click.prevent.stop="$eventHub.$emit(`openTermsConditionsModal_${inputData.id}`)"
                  >{{ $t('dataProcessing.termsConditions') }}</span
                >
              </div>
            </template>
          </template>
        </v-checkbox>
      </div>
    </div>

    <DynamicTermsConditionsModal
      v-if="$te(`${formLangKey}.agreements.termsConditions`, $i18n.locale)"
      :identifier="inputData.id"
    />
    <DocumentModal
      v-else
      :identifier="inputData.id"
      name="termsConditions"
      :category="category"
      type-name="terms_and_conditions"
    />
    <DocumentModal
      :identifier="inputData.id"
      name="cookies"
      :category="category"
      type-name="cookies"
    />
  </div>
</template>

<script>
import { checked } from '@/customVuelidate';
import formGtm from '@/mixins/formGtm';
import { mapGetters } from 'vuex';

export default {
  name: 'UlTermsOfUseAgreement',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      termsOfUseAgreement: false
    };
  },
  validations: {
    termsOfUseAgreement: { checked }
  },
  methods: {
    updateValue() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value: this.$v.termsOfUseAgreement.$model,
        formName: this.formName
      });
    }
  },
  computed: {
    ...mapGetters({
      formLangKey: 'thematicCounselling/formLangKey'
    }),
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    },
    category() {
      let category = 'default';
      if (this.isUlHc) {
        category = 'aeskulab';
      } else if (this.isPutinSucks) {
        category = 'ukrajina';
      }
      return category;
    }
  },
  created() {
    this.$v.termsOfUseAgreement.$model = this.responses[this.formName][this.inputData.id] || false;
    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => {
      this.$v.$touch();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  }
};
</script>
